/**
 * Genel Stok Havuzu Mock Verisi
 * 
 * Malzeme tipi bazında toplam, ayrılmış ve serbest stok.
 * İleride API'den gelecek, şimdilik mock.
 */

export const stokHavuzu = [
    // Demir stokları (çap bazlı)
    {
        id: 'sh-001',
        malzemeTipi: 'demir',
        altTip: 'Ø8',
        birim: 'ton',
        toplamStok: 10,
        ayrilmisStok: 3,
        serbestStok: 7,
        sonGirisTarihi: '2026-01-17',
        sonKullanimTarihi: '2026-01-20',
        depoKonum: 'Ana Depo - A Blok',
    },
    {
        id: 'sh-002',
        malzemeTipi: 'demir',
        altTip: 'Ø12',
        birim: 'ton',
        toplamStok: 5,
        ayrilmisStok: 2,
        serbestStok: 3,
        sonGirisTarihi: '2026-01-15',
        sonKullanimTarihi: '2026-01-22',
        depoKonum: 'Ana Depo - A Blok',
    },
    {
        id: 'sh-003',
        malzemeTipi: 'demir',
        altTip: 'Ø16',
        birim: 'ton',
        toplamStok: 3,
        ayrilmisStok: 0,
        serbestStok: 3,
        sonGirisTarihi: '2026-01-16',
        sonKullanimTarihi: null,
        depoKonum: 'Ana Depo - A Blok',
    },
    {
        id: 'sh-004',
        malzemeTipi: 'demir',
        altTip: 'Ø14',
        birim: 'ton',
        toplamStok: 8,
        ayrilmisStok: 5,
        serbestStok: 3,
        sonGirisTarihi: '2026-01-14',
        sonKullanimTarihi: '2026-01-25',
        depoKonum: 'B Blok Şantiye',
    },

    // Parke stokları (kategori bazlı)
    {
        id: 'sh-010',
        malzemeTipi: 'parke',
        altTip: 'Laminat',
        birim: 'kutu',
        toplamStok: 50,
        ayrilmisStok: 20,
        serbestStok: 30,
        sonGirisTarihi: '2026-01-20',
        sonKullanimTarihi: '2026-01-28',
        depoKonum: 'Ana Depo',
    },
    {
        id: 'sh-011',
        malzemeTipi: 'parke',
        altTip: 'Masif',
        birim: 'kutu',
        toplamStok: 25,
        ayrilmisStok: 10,
        serbestStok: 15,
        sonGirisTarihi: '2026-01-18',
        sonKullanimTarihi: '2026-02-01',
        depoKonum: 'Ana Depo',
    },
    {
        id: 'sh-012',
        malzemeTipi: 'parke',
        altTip: 'Engineered',
        birim: 'kutu',
        toplamStok: 15,
        ayrilmisStok: 0,
        serbestStok: 15,
        sonGirisTarihi: '2026-01-22',
        sonKullanimTarihi: null,
        depoKonum: 'Ana Depo',
    },

    // Tuğla stokları
    { id: 'sh-020', malzemeTipi: 'tugla', altTip: '13.5 Yatay Delikli', birim: 'adet', toplamStok: 15000, ayrilmisStok: 5000, serbestStok: 10000, sonGirisTarihi: '2026-01-18', sonKullanimTarihi: '2026-01-25', depoKonum: 'Ana Depo - Şantiye' },
    { id: 'sh-021', malzemeTipi: 'tugla', altTip: '19 Yatay Delikli', birim: 'adet', toplamStok: 8000, ayrilmisStok: 3000, serbestStok: 5000, sonGirisTarihi: '2026-01-20', sonKullanimTarihi: '2026-01-28', depoKonum: 'Ana Depo - Şantiye' },
    { id: 'sh-022', malzemeTipi: 'tugla', altTip: 'Gazbeton Blok', birim: 'adet', toplamStok: 4000, ayrilmisStok: 1500, serbestStok: 2500, sonGirisTarihi: '2026-01-22', sonKullanimTarihi: '2026-02-01', depoKonum: 'B Blok Şantiye' },

    // İzolasyon stokları
    { id: 'sh-030', malzemeTipi: 'izolasyon', altTip: 'Isı Yalıtım', birim: 'm²', toplamStok: 1200, ayrilmisStok: 400, serbestStok: 800, sonGirisTarihi: '2026-01-15', sonKullanimTarihi: '2026-01-22', depoKonum: 'Ana Depo' },
    { id: 'sh-031', malzemeTipi: 'izolasyon', altTip: 'Su Yalıtım', birim: 'm²', toplamStok: 800, ayrilmisStok: 300, serbestStok: 500, sonGirisTarihi: '2026-01-18', sonKullanimTarihi: '2026-01-25', depoKonum: 'Ana Depo' },
    { id: 'sh-032', malzemeTipi: 'izolasyon', altTip: 'Ses Yalıtım', birim: 'm²', toplamStok: 500, ayrilmisStok: 0, serbestStok: 500, sonGirisTarihi: '2026-01-20', sonKullanimTarihi: null, depoKonum: 'Ana Depo' },

    // Elektrik stokları
    { id: 'sh-040', malzemeTipi: 'elektrik', altTip: 'Kablo', birim: 'mt', toplamStok: 5000, ayrilmisStok: 2000, serbestStok: 3000, sonGirisTarihi: '2026-01-12', sonKullanimTarihi: '2026-01-20', depoKonum: 'Elektrik Deposu' },
    { id: 'sh-041', malzemeTipi: 'elektrik', altTip: 'Priz/Anahtar', birim: 'adet', toplamStok: 400, ayrilmisStok: 150, serbestStok: 250, sonGirisTarihi: '2026-01-16', sonKullanimTarihi: '2026-01-28', depoKonum: 'Elektrik Deposu' },
    { id: 'sh-042', malzemeTipi: 'elektrik', altTip: 'Dağıtım Panosu', birim: 'adet', toplamStok: 20, ayrilmisStok: 12, serbestStok: 8, sonGirisTarihi: '2026-01-10', sonKullanimTarihi: '2026-01-24', depoKonum: 'Ana Depo' },

    // Su Tesisatı stokları
    { id: 'sh-050', malzemeTipi: 'suTesisati', altTip: 'PPR Boru', birim: 'mt', toplamStok: 3000, ayrilmisStok: 1200, serbestStok: 1800, sonGirisTarihi: '2026-01-14', sonKullanimTarihi: '2026-01-22', depoKonum: 'Tesisat Deposu' },
    { id: 'sh-051', malzemeTipi: 'suTesisati', altTip: 'Fitting', birim: 'adet', toplamStok: 1000, ayrilmisStok: 400, serbestStok: 600, sonGirisTarihi: '2026-01-17', sonKullanimTarihi: '2026-01-26', depoKonum: 'Tesisat Deposu' },
    { id: 'sh-052', malzemeTipi: 'suTesisati', altTip: 'Vana/Musluk', birim: 'adet', toplamStok: 200, ayrilmisStok: 80, serbestStok: 120, sonGirisTarihi: '2026-01-20', sonKullanimTarihi: '2026-02-01', depoKonum: 'Tesisat Deposu' },

    // Doğalgaz stokları
    { id: 'sh-060', malzemeTipi: 'dogalgaz', altTip: 'Çelik Boru', birim: 'mt', toplamStok: 1500, ayrilmisStok: 600, serbestStok: 900, sonGirisTarihi: '2026-01-15', sonKullanimTarihi: '2026-01-25', depoKonum: 'Tesisat Deposu' },
    { id: 'sh-061', malzemeTipi: 'dogalgaz', altTip: 'Regülatör', birim: 'adet', toplamStok: 30, ayrilmisStok: 15, serbestStok: 15, sonGirisTarihi: '2026-01-18', sonKullanimTarihi: '2026-01-28', depoKonum: 'Ana Depo' },

    // Alçı/Sıva stokları
    { id: 'sh-070', malzemeTipi: 'alciSiva', altTip: 'Alçı', birim: 'çuval', toplamStok: 300, ayrilmisStok: 120, serbestStok: 180, sonGirisTarihi: '2026-01-16', sonKullanimTarihi: '2026-01-24', depoKonum: 'Ana Depo' },
    { id: 'sh-071', malzemeTipi: 'alciSiva', altTip: 'Sıva', birim: 'çuval', toplamStok: 500, ayrilmisStok: 200, serbestStok: 300, sonGirisTarihi: '2026-01-19', sonKullanimTarihi: '2026-01-27', depoKonum: 'Ana Depo' },
    { id: 'sh-072', malzemeTipi: 'alciSiva', altTip: 'Macun', birim: 'kova', toplamStok: 150, ayrilmisStok: 50, serbestStok: 100, sonGirisTarihi: '2026-01-21', sonKullanimTarihi: null, depoKonum: 'Ana Depo' },

    // Seramik stokları
    { id: 'sh-080', malzemeTipi: 'seramik', altTip: 'Yer Seramiği', birim: 'm²', toplamStok: 800, ayrilmisStok: 350, serbestStok: 450, sonGirisTarihi: '2026-01-17', sonKullanimTarihi: '2026-01-26', depoKonum: 'Ana Depo' },
    { id: 'sh-081', malzemeTipi: 'seramik', altTip: 'Duvar Seramiği', birim: 'm²', toplamStok: 600, ayrilmisStok: 200, serbestStok: 400, sonGirisTarihi: '2026-01-19', sonKullanimTarihi: '2026-01-28', depoKonum: 'Ana Depo' },
    { id: 'sh-082', malzemeTipi: 'seramik', altTip: 'Granit', birim: 'm²', toplamStok: 200, ayrilmisStok: 0, serbestStok: 200, sonGirisTarihi: '2026-01-22', sonKullanimTarihi: null, depoKonum: 'Ana Depo' },

    // Boya stokları
    { id: 'sh-090', malzemeTipi: 'boya', altTip: 'İç Cephe', birim: 'lt', toplamStok: 800, ayrilmisStok: 300, serbestStok: 500, sonGirisTarihi: '2026-01-15', sonKullanimTarihi: '2026-01-25', depoKonum: 'Ana Depo' },
    { id: 'sh-091', malzemeTipi: 'boya', altTip: 'Dış Cephe', birim: 'lt', toplamStok: 500, ayrilmisStok: 200, serbestStok: 300, sonGirisTarihi: '2026-01-18', sonKullanimTarihi: '2026-01-28', depoKonum: 'Ana Depo' },
    { id: 'sh-092', malzemeTipi: 'boya', altTip: 'Astar', birim: 'lt', toplamStok: 300, ayrilmisStok: 100, serbestStok: 200, sonGirisTarihi: '2026-01-20', sonKullanimTarihi: null, depoKonum: 'Ana Depo' },
];

/**
 * Malzeme tipine göre stok havuzu getir
 */
export const getStokHavuzu = (malzemeTipi) => {
    return stokHavuzu.filter(s => s.malzemeTipi === malzemeTipi);
};

/**
 * Alt tipe göre serbest stok getir
 */
export const getSerbestStok = (malzemeTipi, altTip) => {
    const item = stokHavuzu.find(s => s.malzemeTipi === malzemeTipi && s.altTip === altTip);
    return item ? item.serbestStok : 0;
};

/**
 * Toplam serbest stok (malzeme tipi bazlı)
 */
export const getToplamSerbestStok = (malzemeTipi) => {
    return stokHavuzu
        .filter(s => s.malzemeTipi === malzemeTipi)
        .reduce((acc, s) => acc + s.serbestStok, 0);
};
